import React from "react"
import { v4 as uuid } from "uuid"
import {
  Box,
  Button,
  Grid,
  makeStyles,
  TextField,
  Typography,
} from "@material-ui/core"

import { Tag } from "@root/store/types"
import TagsTable from "./TagsTable"

export interface Props {
  tags: Tag[]
  onAddTag(tag: Tag): void
  onRemoveTag(tag: Tag): void
}

const useStyles = makeStyles({
  button: {
    alignSelf: "center",
  },
})

const Tags: React.FC<Props> = ({ tags, onAddTag, onRemoveTag }) => {
  const [tag, setTag] = React.useState("")
  const [group, setGroup] = React.useState("")
  const classes = useStyles()

  return (
    <>
      <TagsTable tags={tags} onRemoveTag={onRemoveTag} />

      <Typography variant="h6">Add New</Typography>
      <Box
        component="form"
        data-qa-selector="tags-form"
        onSubmit={(ev) => {
          ev.preventDefault()
          onAddTag({
            id: uuid(),
            tag,
            group,
          })
          setTag("")
        }}
      >
        <Grid container spacing={2}>
          <Grid item sm={5} xs={12}>
            <TextField
              fullWidth
              required
              data-qa-selector="group-input"
              id="group-id"
              label="Group"
              value={group}
              onChange={(ev) => setGroup(ev.target.value)}
            />
          </Grid>
          <Grid item sm={5} xs={12}>
            <TextField
              fullWidth
              required
              data-qa-selector="tag-input"
              id="tag-id"
              label="Tag"
              value={tag}
              onChange={(ev) => setTag(ev.target.value)}
            />
          </Grid>
          <Grid item sm={2} xs={12} className={classes.button}>
            <Button
              fullWidth
              data-qa-selector="submit"
              type="submit"
              variant="contained"
              disabled={!tag || !group}
            >
              Add
            </Button>
          </Grid>
        </Grid>
      </Box>
    </>
  )
}

export default Tags
